(function () {
  const STORAGE_KEY = 'horizon_wishlist';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  }

  function findItem(list, id) {
    return list.find(function (item) {
      return String(item.id) === String(id);
    });
  }

  function isWishlisted(id) {
    return !!findItem(getWishlist(), id);
  }

  function toggleWishlist(data) {
    const id = String(data.id);
    let list = getWishlist();
    const existing = findItem(list, id);
    if (existing) {
      list = list.filter(function (item) {
        return String(item.id) !== id;
      });
    } else {
      list.push({
        id: id,
        title: data.title || '',
        url: data.url || '',
        image: data.image || '',
        price: data.price || '',
      });
    }
    saveWishlist(list);
    renderDrawer();
    return !existing;
  }

  function removeFromWishlist(id) {
    const list = getWishlist().filter(function (item) {
      return String(item.id) !== String(id);
    });
    saveWishlist(list);
    updateHeaderCounts();
    renderDrawer();
    document
      .querySelectorAll('[data-wishlist-toggle][data-product-id="' + id + '"]')
      .forEach(function (btn) {
        updateButtonState(btn, false);
      });
  }

  function updateButtonState(button, active) {
    button.setAttribute('aria-pressed', active ? 'true' : 'false');
    button.classList.toggle('is-active', active);

    const icon = button.querySelector('[data-wishlist-icon]');
    if (icon) icon.innerHTML = active ? '&#9829;' : '&#9825;';

    const label = button.querySelector('[data-wishlist-label]');
    if (label) {
      label.textContent = active
        ? label.dataset.addedText || 'Added to Wishlist'
        : label.dataset.defaultText || 'Add to Wishlist';
    }
  }

  function updateHeaderCounts() {
    const count = getWishlist().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = String(count);
      el.hidden = count === 0;
    });
  }

  function escapeHtml(str) {
    const div = document.createElement('div');
    div.textContent = str || '';
    return div.innerHTML;
  }

  function renderDrawer() {
    const container = document.querySelector('[data-wishlist-drawer-content]');
    if (!container) return;
    const list = getWishlist();

    if (list.length === 0) {
      const emptyText = container.dataset.emptyText || 'Your wishlist is empty.';
      container.innerHTML = '<p class="wishlist-drawer__empty">' + escapeHtml(emptyText) + '</p>';
      return;
    }

    container.innerHTML = list
      .map(function (item) {
        const title = escapeHtml(item.title);
        const image = item.image
          ? '<img src="' + item.image + '" alt="' + title + '" loading="lazy" width="64" height="64">'
          : '';
        const price = item.price ? '<span class="wishlist-drawer__item-price">' + escapeHtml(item.price) + '</span>' : '';

        return (
          '<div class="wishlist-drawer__item" data-product-id="' + item.id + '">' +
          '<a href="' + item.url + '" class="wishlist-drawer__item-media">' + image + '</a>' +
          '<div class="wishlist-drawer__item-info">' +
          '<a href="' + item.url + '" class="wishlist-drawer__item-title">' + title + '</a>' +
          price +
          '</div>' +
          '<button type="button" class="wishlist-drawer__item-remove" data-wishlist-remove data-product-id="' +
          item.id +
          '" aria-label="Remove">&times;</button>' +
          '</div>'
        );
      })
      .join('');
  }

  function initButton(button) {
    const productId = button.dataset.productId;
    updateButtonState(button, isWishlisted(productId));

    button.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      const data = {
        id: productId,
        title: button.dataset.productTitle,
        url: button.dataset.productUrl,
        image: button.dataset.productImage,
        price: button.dataset.productPrice,
      };
      const active = toggleWishlist(data);
      updateButtonState(button, active);
      updateHeaderCounts();

      document
        .querySelectorAll('[data-wishlist-toggle][data-product-id="' + productId + '"]')
        .forEach(function (btn) {
          if (btn !== button) updateButtonState(btn, active);
        });
    });
  }

  function openDrawer(dialog) {
    renderDrawer();
    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }
  }

  function closeDrawer(dialog) {
    if (typeof dialog.close === 'function') {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
    }
  }

  function initDrawer() {
    const dialog = document.querySelector('[data-wishlist-drawer]');
    if (!dialog || dialog.dataset.wishlistDrawerInit) return;
    dialog.dataset.wishlistDrawerInit = 'true';

    document.querySelectorAll('[data-wishlist-drawer-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        openDrawer(dialog);
      });
    });

    dialog.querySelectorAll('[data-wishlist-drawer-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        closeDrawer(dialog);
      });
    });

    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) closeDrawer(dialog);

      const removeBtn = e.target.closest('[data-wishlist-remove]');
      if (removeBtn) removeFromWishlist(removeBtn.dataset.productId);
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-wishlist-toggle]').forEach(function (button) {
      if (!button.dataset.wishlistInit) {
        button.dataset.wishlistInit = 'true';
        initButton(button);
      }
    });
    updateHeaderCounts();
    initDrawer();
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });

  window.addEventListener('storage', function (e) {
    if (e.key === STORAGE_KEY) {
      updateHeaderCounts();
      renderDrawer();
    }
  });
})();
